var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget"},[_vm._l((_vm.componentList),function(item){return [_c('x-shell',{key:item.id,attrs:{"data":item},on:{"complete":_vm.onShellComplete}},[_vm._v("\n      "+_vm._s(item.componentType)+"\n    ")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }